
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { DanoneDnProductFamilyProduct } from './danone-dn-product-family-product';

export class DanoneDnProductFamily extends BaseEntity {

  danoneDnProductFamilyCode : string;
  name                      : string;
  dayNumber                 : number;
  trendDaysNumber           : number;
  
  danoneDnProductFamilyProducts : DanoneDnProductFamilyProduct[];

  constructor() {
    super();

  }
}

	
